module.exports = __webpack_public_path__ + "img/fy10.38f30370.jpg";